'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var InputAdornment = _interopDefault(require('@material-ui/core/InputAdornment'));
var Search = _interopDefault(require('@material-ui/icons/Search'));
var styledComponents = require('./styled-components.js');

// Deprecated: use OutlinedInputWithIcon instead.
var InputWithIcon = function (props) {
    var title = props.title, onChange = props.onChange, _a = props.Icon, Icon = _a === void 0 ? Search : _a, id = props.id;
    // eslint-disable-next-line no-console
    console.warn('DEPRECATED: use OutlinedInputWithIcon instead.');
    var handleChange = function (e) {
        e.persist();
        onChange(e);
    };
    return (React__default.createElement(styledComponents.Main, null,
        React__default.createElement(styledComponents.StyledInput, { id: id, placeholder: title, onChange: handleChange, startAdornment: React__default.createElement(InputAdornment, { position: 'start' },
                React__default.createElement(Icon, null)) })));
};

module.exports = InputWithIcon;
